(function() {
    'use strict';
    angular
        .module('bhsApp')
        .factory('ParamFormulaire', ParamFormulaire);

    ParamFormulaire.$inject = ['$resource'];

    function ParamFormulaire ($resource) {
        var resourceUrl =  'api/param-formulaires/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'loadAll' : {
                url: 'api/all-param-formulaires',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
